import React from 'react';
import { Button } from './ui/button';
import { ArrowRight, Instagram, Facebook } from 'lucide-react';
import { agentInfo } from '../mockData';

export const Footer = ({ onContactClick }) => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-stone-900 text-stone-300" data-testid="site-footer">
      {/* CTA Banner */}
      <div className="border-b border-stone-800">
        <div className="container mx-auto px-6 lg:px-12 py-16 md:py-24">
          <div className="max-w-3xl">
            <h2 className="font-light text-white leading-[0.95]" data-testid="footer-cta-title">
              <span className="block text-4xl sm:text-5xl md:text-7xl italic font-serif tracking-tight">Pronto</span>
              <span className="block text-[10px] sm:text-xs md:text-sm tracking-[0.35em] uppercase font-extralight text-stone-400 my-5 md:my-7">para encontrar o</span>
              <span className="block text-5xl sm:text-6xl md:text-8xl italic font-serif uppercase tracking-tight">Seu sonho?</span>
            </h2>
            <div className="mt-8 md:mt-10">
              <Button
                onClick={onContactClick}
                data-testid="footer-cta-button"
                className="bg-white text-stone-900 hover:bg-stone-100 px-8 py-6 text-sm font-medium tracking-wide rounded-none group min-h-[52px]"
              >
                Fala comigo
                <ArrowRight className="ml-3 w-4 h-4 group-hover:translate-x-1 transition-transform" />
              </Button>
            </div>
          </div>
        </div>
      </div>

      {/* Main Footer */}
      <div className="container mx-auto px-6 lg:px-12 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-16">
          {/* Brand */}
          <div className="md:col-span-2">
            <div className="text-2xl font-light text-white tracking-tight" data-testid="footer-brand">
              Rustem<span className="text-stone-500">.</span>
            </div>
            <div className="flex items-center gap-2 mt-3">
              <img
                src="https://customer-assets.emergentagent.com/job_imoveis-faro-pt/artifacts/pvj0xi3c_bala%CC%83o%20SEM%20SOMBRA%20%281%29.png"
                alt="RE/MAX Platina"
                className="h-7 w-auto opacity-90"
                data-testid="remax-balloon-footer"
              />
              <span className="text-[11px] text-stone-500 tracking-wide uppercase">Platina · Portimão</span>
            </div>
            <p className="text-stone-400 mt-6 font-light text-sm leading-relaxed max-w-sm italic">
              Consultor imobiliário em Portimão. 10 anos da RE/MAX Platina ao seu serviço, em todo o Algarve.
            </p>
          </div>

          {/* Links */}
          <div>
            <h3 className="text-xs tracking-[0.2em] uppercase text-stone-500 font-medium mb-6">Navegação</h3>
            <ul className="space-y-4">
              <li><button onClick={() => document.getElementById('services').scrollIntoView({ behavior: 'smooth' })} className="text-sm text-stone-300 hover:text-white transition-colors" data-testid="footer-link-services">Serviços</button></li>
              <li><button onClick={() => document.getElementById('about').scrollIntoView({ behavior: 'smooth' })} className="text-sm text-stone-300 hover:text-white transition-colors" data-testid="footer-link-about">Sobre</button></li>
              <li><button onClick={() => document.getElementById('testimonials').scrollIntoView({ behavior: 'smooth' })} className="text-sm text-stone-300 hover:text-white transition-colors" data-testid="footer-link-testimonials">Testemunhos</button></li>
              <li><button onClick={onContactClick} className="text-sm text-stone-300 hover:text-white transition-colors" data-testid="footer-link-contact">Contacto</button></li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-xs tracking-[0.2em] uppercase text-stone-500 font-medium mb-6">Contacto</h3>
            <ul className="space-y-4 text-sm">
              <li><a href={`tel:${agentInfo.phone}`} className="text-stone-300 hover:text-white transition-colors" data-testid="footer-phone">{agentInfo.phone}</a></li>
              <li><a href={`mailto:${agentInfo.email}`} className="text-stone-300 hover:text-white transition-colors" data-testid="footer-email">{agentInfo.email}</a></li>
              <li className="text-stone-300" data-testid="footer-location">{agentInfo.location}</li>
            </ul>
            <div className="flex gap-3 mt-6">
              <a href="https://www.instagram.com/rustem.rusu?igsh=MWE2emVrczhqdjgzZA%3D%3D&utm_source=qr" target="_blank" rel="noopener noreferrer" data-testid="social-instagram" className="text-stone-500 hover:text-white transition-colors" aria-label="Instagram"><Instagram className="w-4 h-4" strokeWidth={1.5} /></a>
              <a href="https://www.facebook.com/share/1GwdWuHU8K/?mibextid=wwXIfr" target="_blank" rel="noopener noreferrer" data-testid="social-facebook" className="text-stone-500 hover:text-white transition-colors" aria-label="Facebook"><Facebook className="w-4 h-4" strokeWidth={1.5} /></a>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-stone-800 pt-8 flex flex-col md:flex-row justify-between items-start md:items-center gap-4">
          <p className="text-xs text-stone-500">
            © {currentYear} Rustem · RE/MAX Platina Portimão. AMI: {agentInfo.license}
          </p>
          <div className="flex gap-6">
            <a href="#" className="text-xs text-stone-500 hover:text-white transition-colors">Privacidade</a>
            <a href="#" className="text-xs text-stone-500 hover:text-white transition-colors">Termos</a>
          </div>
        </div>
      </div>
    </footer>
  );
};
